import React, { type FC, memo } from "react";
import { Chip, cn, ProgressBar } from "@heroui/react";
import { CircleCheck } from "@gravity-ui/icons";

export type Step = {
    number: number;
    label: string;
    isComplete: boolean;
    isLoading: boolean;
    displayValue?: string;
};

type StepProgressIndicatorProps = {
    steps: Step[];
    show: boolean;
};

const StepProgressIndicatorImpl: FC<StepProgressIndicatorProps> = ({ steps, show }) => {
    return (
        <div
            className={cn("flex flex-col gap-2 w-full transition-[opacity] duration-200 ease-in-out opacity-0", {
                "opacity-100": show,
            })}
        >
            {steps.map((step) => (
                <div key={step.number} className="flex w-full items-center justify-between">
                    <div className="flex items-center gap-2">
                        <Chip color={step.isComplete ? "success" : "default"}>{step.number}</Chip>
                        <span>{step.label}</span>
                    </div>
                    {step.isLoading ? (
                        <ProgressBar isIndeterminate size="sm" className="w-72" aria-label={step.label}>
                            <ProgressBar.Track>
                                <ProgressBar.Fill />
                            </ProgressBar.Track>
                        </ProgressBar>
                    ) : step.isComplete ? (
                        <div className="flex items-center gap-2">
                            {step.displayValue && <span>{step.displayValue}</span>}
                            <CircleCheck className="text-green-500 size-4" />
                        </div>
                    ) : null}
                </div>
            ))}
        </div>
    );
};

export const StepProgressIndicator = memo(StepProgressIndicatorImpl);
